import React from 'react';

interface CheckoutSectionFooterProps {
  children?: any;
  className?: string;
}

const CheckoutSectionFooter = ({
  children,
  className,
}: CheckoutSectionFooterProps) => (
  <div className={className}>{children}</div>
);

export default CheckoutSectionFooter;
